import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
const StyledPre = styled('pre')(({ theme })=>({
        fontSize: '0.875rem',
        lineHeight: 1.6,
        margin: 0,
        overflow: 'auto',
        padding: theme.spacing(2),
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    }));
export const Pre = (props)=>/*#__PURE__*/ _jsx(StyledPre, {
        ...props,
        "data-component": "pre"
    });
Pre.displayName = 'Pre';

//# sourceMappingURL=Pre.js.map